import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sub-status-update-dialog',
  templateUrl: './sub-status-update-dialog.component.html',
  styleUrls: ['./sub-status-update-dialog.component.scss']
})
export class SubStatusUpdateDialogComponent implements OnInit {

  notes: string = '';
  images: string[] = []; // store filenames
  
  public serverPath = environment.commonImageApi + "stageHistory/";

  constructor(
    public dialogRef: MatDialogRef<SubStatusUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  getImage(event: any) {
    if (event && event['productEntityMediaGallery'] && event['productEntityMediaGallery'].length > 0) {
      this.images.push(event['productEntityMediaGallery'][0].fileName);
    }
  }

  removeImage(index: number) {
    this.images.splice(index, 1);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  get isValid(): boolean {
    if (this.data.requireNotes && (!this.notes || this.notes.trim() === '')) {
      return false;
    }
    if (this.data.requireImages && this.images.length === 0) {
      return false;
    }
    return true;
  }

  text: string = 'Update & Save';

  async onSave(): Promise<void> {
    if (!this.isValid) return;
    this.text = 'Processing...';
    
    const payload = {
      notes: this.notes,
      images: this.images.length > 0 ? JSON.stringify(this.images) : null
    };

    if (this.data.saveCallback) {
      try {
        await this.data.saveCallback(payload);
        this.dialogRef.close(true);
      } catch (err) {
        this.text = 'Update & Save';
      }
    } else {
      this.dialogRef.close(payload);
    }
  }

}
